import { render, staticRenderFns } from "./egrulRecordsModal.vue?vue&type=template&id=21aa2114&scoped=true&"
import script from "./egrulRecordsModal.vue?vue&type=script&lang=js&"
export * from "./egrulRecordsModal.vue?vue&type=script&lang=js&"
import style0 from "./egrulRecordsModal.vue?vue&type=style&index=0&id=21aa2114&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa2114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21aa2114')) {
      api.createRecord('21aa2114', component.options)
    } else {
      api.reload('21aa2114', component.options)
    }
    module.hot.accept("./egrulRecordsModal.vue?vue&type=template&id=21aa2114&scoped=true&", function () {
      api.rerender('21aa2114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/egrulRecords/egrulRecordsModal.vue"
export default component.exports